export const isEmptyString = (originalString: string): boolean => {
  const trimmedString = originalString?.trim();
  return !trimmedString || trimmedString.length === 0;
};

/**
 * URL에서 도메인만 추출합니다
 * @param url - 도메인을 추출할 URL
 * @returns 도메인 부분만
 */
export function extractDomain(url: string): string {
  const match = url.match(/^https?:\/\/([^/]+)/);
  return match ? match[1] : url;
}
